import Header from './components/Header';
import Hero from './components/Hero';
import FaqSection from './components/FaqSection';
import CardsSection from './components/CardsSection';
import IndexSection from './components/IndexSection';
import AppSection from './components/AppSection';
import TopicsSection from './components/TopicsSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import FeaturesSection from './components/FeaturesSection';
import MediaSection from './components/MediaSection';
import CarouselSection from './components/CarouselSection';
import CommentsSection from './components/CommentsSection';
import UpdatesSection from './components/UpdatesSection';
import RankingSection from './components/RankingSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <FaqSection />
        <CardsSection />
        <IndexSection />
        <AppSection />
        <TopicsSection />
        <AboutSection />
        <ContactSection />
        <FeaturesSection />
        <MediaSection />
        <CarouselSection />
        <CommentsSection />
        <UpdatesSection />
        <RankingSection />
      </main>
      <Footer />
    </>
  );
}